import React from 'react';
import { Link } from "react-router-dom";
import API from '../../tools/API';
import { getDate } from '../../tools/getDate';

import style from './SingleVoatingCathegoryTile.module.scss';

interface ModalData {
    id: number | undefined,
    name: string | undefined,
    generate: boolean | undefined
}

interface Props {
    id: number,
    name: string,
    pollCount: number,
    votingTo: string,
    openModal: React.Dispatch<React.SetStateAction<ModalData | boolean>> | boolean,
    results?: boolean
}

const SingleVoatingCathegoryTile: React.FC<Props> = ({ id, name, openModal, pollCount, votingTo, results }) => {

    const modalOpening = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        typeof openModal !== 'boolean' && API.getSingleCategory(id.toString()).then(res => {
            const cat = res?.data.data
            openModal({ id: cat?.id, name: cat?.name, generate: cat?.autoGenerateNextPoll });
        })
    }

    return (
        <>
            <Link
                className={style.SingleVoatingCathegoryTile}
                to={results ? `/listawynikow/${id}` : `/listaglosowan/${id}`}
            >
                <div>
                    <div className={style.editRow}>
                        {openModal && <button
                            className={style.btnEdit}
                            onClick={(e) => modalOpening(e)}
                        >
                            Edytuj
                        </button>}
                        {!openModal && <div style={{ height: "50px" }}></div>}
                    </div>
                    <div className={style.content}>

                        <h2 className={style.SingleVoatingCathegoryTile__title}>{name}</h2>

                        <p className={style.SingleVoatingCathegoryTile__notes}>Liczba notowań: {pollCount}</p>
                        <p className={style.SingleVoatingCathegoryTile__voting}>Ostatnie głosowanie do: <span>{getDate(votingTo)}</span></p>
                    </div>
                    <div className={style.btnMore}>
                        <p>Więcej</p>
                    </div>
                </div>
            </Link>
        </>
    )
}

export default SingleVoatingCathegoryTile